var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 3C3.7835 3 3 3.7835 3 4.75V20.747C3 21.8068 4.23607 22.3857 5.05023 21.7073L6.66168 20.3644C6.70661 20.327 6.76324 20.3065 6.82173 20.3065H18.5565C19.5229 20.3065 20.3065 19.5229 20.3065 18.5565V14.5C20.3065 14.0858 19.9707 13.75 19.5565 13.75C19.1422 13.75 18.8065 14.0858 18.8065 14.5V18.5565C18.8065 18.6945 18.6945 18.8065 18.5565 18.8065H6.82173C6.41234 18.8065 6.01591 18.95 5.7014 19.2121L4.5 20.2132V4.75C4.5 4.61193 4.61193 4.5 4.75 4.5H9C9.41421 4.5 9.75 4.16421 9.75 3.75C9.75 3.33579 9.41421 3 9 3H4.75ZM20.1365 3.74222V9.22023C20.1365 9.66568 19.5979 9.88877 19.2829 9.57378L17.7414 8.0323L12.5065 13.2672C12.3113 13.4624 11.9947 13.4624 11.7994 13.2672L10.1115 11.5792C9.91625 11.384 9.91625 11.0674 10.1115 10.8721L15.3464 5.63726L13.8049 4.09577C13.4899 3.78079 13.713 3.24222 14.1584 3.24222L19.6365 3.24222C19.9126 3.24222 20.1365 3.46608 20.1365 3.74222Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7a95a1ec.svg";
export { ForwardRef as ReactComponent };